<div class="upvote-container">
	<span>{{upvotes}}</span>
	<img src="/assets/images/forum/up-arrow.svg" [alt]="upvotes + 'People liked'" height="15" width="15"
		*ngIf="!isUpvoted">
	<img src="/assets/images/forum/arrow-upward-filled.svg" [alt]="upvotes + 'People liked'" height="15" width="15"
		*ngIf="isUpvoted">
</div>